/**
 * Card Component - The Intelligent Standard
 *
 * Clean card with sophisticated hover interactions.
 */

import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outlined' | 'dark';
  hover?: boolean;
  animate?: boolean;
}

export function Card({
  children,
  padding = 'md',
  variant = 'default',
  hover = false,
  animate = false,
  className = '',
  style,
  ...props
}: CardProps) {
  const paddingMap = {
    none: '0',
    sm: '16px',
    md: '24px',
    lg: '32px',
  };

  const variantStyles = {
    default: {
      background: '#FFFFFF',
      border: '1px solid #E8E0D8',
    },
    outlined: {
      background: '#FFFFFF',
      border: '1px solid #E8E0D8',
    },
    dark: {
      background: '#2D2D2D',
      border: '1px solid #3D3D3D',
    },
  };

  const v = variantStyles[variant];

  return (
    <div
      className={`
        rounded-xl
        ${hover ? 'card-arena cursor-pointer' : ''}
        ${animate ? 'animate-fade-up' : ''}
        ${className}
      `}
      style={{
        padding: paddingMap[padding],
        background: v.background,
        border: v.border,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
}
